import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Considerations from './Considerations';
import AdditionalCommissions from './AdditionalCommissions';
import useVoucherValidation from '../useVoucherValidation';

const PAGE_NUMBER = 3.1;

const ConsiderationTab = ({ extractionResults, onPageRefClick, onAcceptExtraction }) => {
  const { id, dealType, voucherId } = useSelector(state => ({
    id: state.deal.deal?.id,
    dealType: state.deal.deal?.deal_type,
    voucherId: state.voucher.voucher?.id,
  }));
  const { showPageValidation } = useVoucherValidation(voucherId, PAGE_NUMBER);
  return (
    <div className="considerations-tab horizontal-overflow">
      {dealType !== 'other' && dealType !== 'consulting' && (
        <Considerations
          dealId={id}
          dealType={dealType}
          showValidation={showPageValidation}
          extractionResults={extractionResults}
          onPageRefClick={onPageRefClick}
          onAcceptExtraction={onAcceptExtraction}
        />
      )}
      <AdditionalCommissions dealId={id} dealType={dealType} showValidation={showPageValidation} />
    </div>
  );
};

ConsiderationTab.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  extractionResults: PropTypes.array,
  onPageRefClick: PropTypes.func,
  onAcceptExtraction: PropTypes.func,
};

ConsiderationTab.defaultProps = {
  extractionResults: [],
  onPageRefClick: null,
  onAcceptExtraction: null,
};

export default ConsiderationTab;
